import {
  UserLocale, UserManagementData, UserRole,
} from '../../../dtos/user.dto';
import {
  addMocks, APIRequest, formatRequestParams, Paginated,
} from '../../types';
import Mocks from './mocks';
import { UsersAPI } from './types';
import { axiosAuthClient } from '../../auth/axiosAuthClient';
import { mapToUpdateUserRequest } from './mappers';

const defaultUrl = '/apiRes';
const v1Path = '/v1';

export const getUsersAPI = (baseUrl = defaultUrl) => {
  const defaultV1Url = `${baseUrl}${v1Path}`;

  const api: UsersAPI = {
    getUserLocales: new APIRequest(
      () => axiosAuthClient.get<Paginated<UserLocale>>(`${defaultV1Url}/locales`).then(({ data }) => data),
      { urlRegexp: '\\/api\\/locales', method: 'get' },
    ),
    getUserRoles: new APIRequest(
      () => axiosAuthClient.get<Paginated<UserRole>>(`${defaultV1Url}/roles?limit=100`).then(({ data }) => data),
      { urlRegexp: '\\/api\\/roles', method: 'get' },
    ),
    getUsers: new APIRequest(
      (params) => axiosAuthClient.get<UserManagementData[]>(`${defaultV1Url}/users`, { params: formatRequestParams(params) }).then(({ data }) => data),
      { urlRegexp: '\\/api\\/users', method: 'get' },
    ),
    createUser: new APIRequest(
      (params) => axiosAuthClient.post<UserManagementData>(`${defaultV1Url}/users`, params).then(({ data }) => data),
      { urlRegexp: '\\/api\\/users', method: 'post' },
    ),
    updateUser: new APIRequest(
      (params) => axiosAuthClient.put<UserManagementData>(`${defaultV1Url}/users/${params.currentUsername}`, mapToUpdateUserRequest(params)).then(({ data }) => data),
      { urlRegexp: '\\/api\\/users\\/[a-zA-Z0-9\\-]+', method: 'put' },
    ),
    resetUserPassword: new APIRequest(
      (params) => axiosAuthClient.put(`${defaultV1Url}/users/${params.username}/password`),
      { urlRegexp: '\\/api\\/users\\/[a-zA-Z0-9\\-]+\\/password', method: 'put' },
    ),
    deleteUser: new APIRequest(
      (username) => axiosAuthClient.delete(`${defaultV1Url}/users/${username}`),
      { urlRegexp: '\\/api\\/users\\/[a-zA-Z0-9\\-]+', method: 'delete' },
    ),
  };

  

  return api;
};
